<template>
    <div>
        <innerheader />
        <compareplan />
    </div>
</template>

<script>
// @ is an alias to /src
import innerheader from "@/components/innerheader/innerheader.vue";
import compareplan from "@/components/compareplan/compareplan.vue";

export default {
  name: 'policyquote',
  components: {
     innerheader,
     compareplan
  }
}
</script>

<style scoped lang="scss">
@import '~@/assets/scss/components/compare-plan.scss';
</style>